"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSecondaryResponseType = exports.getPrimaryResponseType = void 0;
const objects_1 = require("../objects");
function getPrimaryResponseType(repoOrRequestOrConstructor, serviceName) {
    var _a, _b, _c, _d;
    let ResponseType;
    // from service repository
    if (serviceName) {
        ResponseType = (_b = (_a = repoOrRequestOrConstructor[serviceName]) === null || _a === void 0 ? void 0 : _a.Request) === null || _b === void 0 ? void 0 : _b[objects_1.responseTypeSymbol];
    }
    // from request
    else {
        ResponseType = (_c = repoOrRequestOrConstructor === null || repoOrRequestOrConstructor === void 0 ? void 0 : repoOrRequestOrConstructor[objects_1.responseTypeSymbol]) !== null && _c !== void 0 ? _c : (_d = repoOrRequestOrConstructor === null || repoOrRequestOrConstructor === void 0 ? void 0 : repoOrRequestOrConstructor.constructor) === null || _d === void 0 ? void 0 : _d[objects_1.responseTypeSymbol];
    }
    // primary type
    if (Array.isArray(ResponseType)) {
        ResponseType = ResponseType[0];
    }
    return ResponseType;
}
exports.getPrimaryResponseType = getPrimaryResponseType;
function getSecondaryResponseType(repoOrRequestOrConstructor, serviceName) {
    var _a, _b, _c, _d;
    let ResponseType;
    // from service repository
    if (serviceName) {
        ResponseType = (_b = (_a = repoOrRequestOrConstructor[serviceName]) === null || _a === void 0 ? void 0 : _a.Request) === null || _b === void 0 ? void 0 : _b[objects_1.responseTypeSymbol];
    }
    // from request
    else {
        ResponseType = (_c = repoOrRequestOrConstructor === null || repoOrRequestOrConstructor === void 0 ? void 0 : repoOrRequestOrConstructor[objects_1.responseTypeSymbol]) !== null && _c !== void 0 ? _c : (_d = repoOrRequestOrConstructor === null || repoOrRequestOrConstructor === void 0 ? void 0 : repoOrRequestOrConstructor.constructor) === null || _d === void 0 ? void 0 : _d[objects_1.responseTypeSymbol];
    }
    // secondary type
    if (Array.isArray(ResponseType)) {
        ResponseType = ResponseType[1];
    }
    return ResponseType;
}
exports.getSecondaryResponseType = getSecondaryResponseType;
//# sourceMappingURL=core.js.map